import React, { useEffect, useState } from 'react'
// import axios from 'axios'
import PhoneField from './PhoneField'
import PhoneFieldWrapper from './PhoneFieldWrapper'

function PhoneFieldWithCountry(props) {
  const [defaultCountry, setDefaultCountry] = useState('gb')

  // ADD IF YOU NEED AUTOMATIC COUNTRY DETECTION
  // useEffect(() => {
  //   const getCurrentCountry = async () => {
  //     try {
  //       let currentCountry = localStorage.getItem('current_country')

  //       if (!currentCountry) {
  //         const response = await axios.get('https://freeipapi.com/api/json')

  //         if (!response.data?.countryCode) {
  //           throw new Error('Failed fetching current country')
  //         }

  //         currentCountry = response.data.countryCode.toLowerCase()

  //         localStorage.setItem('current_country', currentCountry)
  //       }

  //       setDefaultCountry(currentCountry)
  //     } catch (error) {
  //       console.error('Error fetching current country:', error)
  //     }
  //   }

  //   getCurrentCountry()
  // }, [])

  return defaultCountry ? (
    <PhoneFieldWrapper {...props} defaultCountry={defaultCountry} />
  ) : (
    <PhoneField {...props} />
  )
}

export default PhoneFieldWithCountry
